import { SVGProps } from 'react';

const IcAccount = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      {...props}
    >
      <path
        d='M16.6117 7.44567C16.6117 9.8025 14.9139 12.1635 11.9357 12.1635C8.9575 12.1635 7.33063 9.8025 7.33063 7.44567C7.33063 5.08883 8.87747 2.80701 11.9357 2.80701C14.6876 2.80701 16.6117 5.08883 16.6117 7.44567ZM16.2409 12.2401C17.5537 11.0605 18.3794 9.3495 18.3794 7.44567C18.3794 3.88694 15.4944 1.00202 11.9357 1.00202C8.37698 1.00202 5.49206 3.88694 5.49206 7.44567C5.49206 9.35865 6.32568 11.0769 7.64947 12.2571C4.54904 12.7644 2.18311 15.4558 2.18311 18.6997V20.8218C2.18311 22.0237 3.15743 22.998 4.35932 22.998H19.6407C20.8426 22.998 21.8169 22.0237 21.8169 20.8218V18.6997C21.8169 15.4177 19.395 12.7012 16.2409 12.2401ZM8.71176 14.0498H15.2882C17.692 14.0498 20.2712 16.296 20.2712 18.6997V21.3312H3.63318L3.63318 18.6997C3.63318 16.296 6.30798 14.0498 8.71176 14.0498Z'
        fill-rule='evenodd'
        clip-rule='evenodd'
        fill={props.fill || '#232F3E'}
      />
    </svg>
  );
};

export default IcAccount;
